import {type ActionTree} from 'vuex';

const actions: ActionTree<ModuleGalleryState, RootState> = {
    fetch({commit}, options: GallerySettingsFetchOptions = {})
    {
        options.setLoading = 'undefined' === typeof options.setLoading ? true : options.setLoading;

        return this.dispatch('getPage',
            {
                'url': '/gallery/fetch-data',
                setLoading: options.setLoading,
            },
        ).then(({data: {data}}) =>
        {
            data.lastUpdate         = Date.now();
            data.zipDownloadAllowed = '1' === data.zipDownloadAllowed;
            data.listViewCover      = '1' === data.listViewCover;
            commit('update', data);
        });
    },
};

export default actions;